import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { encryptStorage } from '../slices/authSlice'
import { setHiddenProfile } from '../slices/navigationSlice'

const InAppPage = () => {
	const [searchParams] = useSearchParams()
	const dispatch = useDispatch()

	useEffect(() => {
		window.sessionStorage.setItem('fakeLogin', true)
		window.sessionStorage.setItem('hiddenProfile', true)

		encryptStorage.setItem('rft', searchParams.get('token'))
		dispatch(setHiddenProfile(true))

		window.location.href = searchParams.get('redirectURL')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return null
}

export default InAppPage
